/* tjs <- version.ts */

export const version = '1.7.5';